import { render, staticRenderFns } from "./facets-list-panel.vue?vue&type=template&id=2255f731&scoped=true&"
import script from "./facets-list-panel.ts?vue&type=script&lang=ts&"
export * from "./facets-list-panel.ts?vue&type=script&lang=ts&"
import style0 from "./facets-list-panel.scss?vue&type=style&index=0&id=2255f731&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255f731",
  null
  
)

export default component.exports